(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/create-game/assets/javascripts/create-game-form.js') >= 0) return;  svs.modules.push('/components/marketplace/create-game/assets/javascripts/create-game-form.js');

'use strict';

const _excluded = ["teamPathName"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const {
  useState
} = React;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  useParams
} = ReactRouterDOM;
const {
  Button,
  ReactIcon
} = svs.ui;
const {
  Inputv2: Input
} = svs.ui.reactForm;
const {
  ContentRevealReact: ContentReveal
} = svs.components;
const {
  AdvancedOptions
} = svs.components.marketplace.createGame;
const {
  helpers
} = svs.components.marketplace.createGame;
const {
  actions
} = svs.components.marketplaceData.games;
const {
  betProposal: betProposalSelectors,
  games,
  form
} = svs.components.marketplaceData.selectors;
const {
  showDialog
} = svs.components.marketplaceData.dialogWrapper.actions;
const {
  hooks
} = svs.components.marketplace.createGame;
const {
  getRowId
} = svs.components.marketplace.helpers;
const {
  changeFractionPrice,
  changeDescription
} = svs.components.marketplaceData.createGame.actions;
const MIN_FRACTION_PRICE = 0;
const MAX_FRACTION_PRICE = 10001;
const CreateGameForm = _ref => {
  let {
    isEditMode,
    isLoading
  } = _ref;
  const dispatch = useDispatch();
  const {
    redirectToTeam
  } = hooks.useRedirectTo();
  const _useParams = useParams(),
    {
      teamPathName
    } = _useParams,
    params = _objectWithoutProperties(_useParams, _excluded);
  const activatedDrawId = parseInt(params.activatedDrawId, 10);
  const containerId = parseInt(params.containerId, 10);
  const groupId = parseInt(params.groupId, 10);
  const {
    handleSubmit
  } = hooks.useGameSubmit({
    isEditMode
  });
  const {
    selectedProduct,
    selectedDraw,
    description,
    fractionPrice,
    maxFractionsPerMember,
    buyStopDiff
  } = useSelector(state => state.CreateGame);
  const isPriceValid = fractionPrice > MIN_FRACTION_PRICE && fractionPrice < MAX_FRACTION_PRICE;
  const priceIsSet = fractionPrice !== undefined;
  const betProposalKey = activatedDrawId || getRowId(selectedProduct, selectedDraw, groupId);
  const isRemoving = useSelector(state => games.getIsRemoving(state, {
    activatedDrawId,
    groupId
  }));
  const hasFormChanged = useSelector(state => form.selectIsFormChanged(state, {
    activatedDrawId,
    groupId
  }));
  const betProposal = useSelector(state => betProposalSelectors.selectCreateBetProposal(state, {
    activatedDrawId: betProposalKey
  })) || {};
  const [advancedOptionVisiblity, toggleAdvancedOptions] = useState(() => {
    var _svs, _svs2;
    const DEFAULT_BUY_STOP = 0;
    const defaultBuyStopDiff = ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.marketplace) === null || _svs === void 0 ? void 0 : _svs.data.initialState.Config.selectedBuyStop) || ((_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.marketplace_retail_admin) === null || _svs2 === void 0 ? void 0 : _svs2.data.initialState.Config.selectedBuyStop) || DEFAULT_BUY_STOP;
    return maxFractionsPerMember > 1 || buyStopDiff !== defaultBuyStopDiff || betProposal && helpers.betProposalHasTrue(betProposal) || false;
  });
  const disableButtons = isLoading || isRemoving;
  const dialogOptions = {
    title: 'Vill du verkligen radera spelet?',
    text: 'Alla insatser kommer att betalas tillbaka till lagets medlemmar.',
    icon: 'dustbin',
    buttons: [{
      text: 'Avbryt',
      classes: {
        inverted: true
      }
    }, {
      text: 'Radera',
      callback: async () => {
        dispatch(actions.removeGameAction(groupId, containerId, err => {
          if (!err) {
            redirectToTeam({
              strategy: 'replace',
              groupId,
              teamPathName
            });
          }
        }));
      }
    }]
  };
  const formatFractionPrice = value => {
    const _value = value.replace(/[^0-9]/g, '');
    return _value ? parseInt(_value, 10) : undefined;
  };
  const getButtonLabel = () => {
    if (isLoading) {
      return 'Sparar...';
    }
    if (isEditMode) {
      return 'Spara ändringar';
    }
    return 'Öppna för köp';
  };
  const handleOnRemoveButtonClick = () => {
    dispatch(showDialog(dialogOptions));
  };
  return React.createElement("form", {
    className: "create-game-form",
    onSubmit: handleSubmit
  }, React.createElement("div", {
    className: "control-group fraction-price input-v2-bg-white margin-top-2"
  }, React.createElement("div", {
    className: "h4 margin-bottom-1"
  }, "Andelspris"), React.createElement(Input, {
    autoComplete: "off",
    className: "qa-fraction-price",
    "data-testid": "fraction-price",
    disabled: isEditMode,
    id: "create-game-input-price",
    label: "Hur mycket ska var och en l\xE4gga?",
    onChange: _ref2 => {
      let {
        target
      } = _ref2;
      return dispatch(changeFractionPrice(formatFractionPrice(target.value)));
    },
    suffix: "kr",
    type: "tel",
    value: String(fractionPrice || '')
  }), !isPriceValid && priceIsSet && priceIsSet && React.createElement("div", {
    className: "error-message"
  }, "Insatsen f\xE5r inte vara h\xF6gre \xE4n 10 000 kr.")), React.createElement("div", {
    className: "control-group input-v2-bg-white margin-bottom-1"
  }, React.createElement(Input, {
    className: "description-input qa-description",
    id: "create-game-input-description",
    label: "Beskrivning (frivilligt)",
    maxLength: 900,
    multiline: true,
    onChange: _ref3 => {
      let {
        target
      } = _ref3;
      return dispatch(changeDescription(target.value));
    },
    placeholder: "Kort beskrivning av spelet",
    value: description
  })), React.createElement(Button, {
    block: true,
    className: "qa-toggle-advanced-options margin-bottom-1 margin-top-2",
    onClick: () => toggleAdvancedOptions(prev => !prev),
    transparent: true,
    type: "button"
  }, "FLER VAL", React.createElement(ReactIcon, {
    class: "margin-left marketplace-rotate".concat(advancedOptionVisiblity ? ' marketplace-rotate-180' : ''),
    icon: "menu-down",
    size: "200"
  })), React.createElement(ContentReveal, {
    show: advancedOptionVisiblity
  }, React.createElement(AdvancedOptions, {
    activatedDrawId: parseInt(activatedDrawId, 10),
    groupId: Number(groupId),
    isEditMode: isEditMode
  }), React.createElement("div", {
    className: "bg-grey-600 margin-top-1 margin-bottom-1",
    style: {
      height: 1
    }
  })), isEditMode && React.createElement(React.Fragment, null, React.createElement(Button, {
    block: true,
    className: "qa-remove-button btn-icon-left delete-game-btn",
    "data-testid": "remove-button",
    disabled: disableButtons,
    onClick: handleOnRemoveButtonClick,
    size: 300,
    transparent: true,
    type: "button"
  }, React.createElement(ReactIcon, {
    icon: "dustbin"
  }), isRemoving ? 'Raderar...' : 'Radera spelet'), React.createElement("p", {
    className: "f-center fc-red delete-info-text"
  }, "Alla insatser betalas tillbaka om spelet raderas.")), React.createElement(Button, {
    block: true,
    className: "margin-bottom-1 qa-submit-button",
    "data-testid": "submit-button",
    disabled: !isPriceValid || disableButtons || !hasFormChanged && isEditMode,
    focus: !isEditMode,
    inverted: isEditMode,
    size: 300,
    type: "submit"
  }, getButtonLabel()), !isEditMode && React.createElement("p", {
    className: "f-400"
  }, "N\xE4r alla lagmedlemmar har k\xF6pt andelar kan lagkapten eller speladmin l\xE4mna in spelet. Den som startar spelet k\xF6per automatiskt en andel."));
};
setGlobal('svs.components.marketplace.createGame.CreateGameForm', CreateGameForm);

 })(window);